<!-- <lib-gung-text-input
  gungTranslate="CAMPAIGN_CODE"
  (change)="validateInput($event.target.value)"
  [(ngModel)]="value"
  [extraInputClass]="extraClasses"
  [renderStatic]="disabled"
></lib-gung-text-input> -->
<div class="form-group mb-0">
  <label translate>
    {{ label }}
  </label>
  <div class="input-group">
    <input
      type="text"
      class="form-control"
      (input)="onInputChange($event.target.value)"
      [(ngModel)]="pendingValue"
      [class]="extraClasses"
      [disabled]="disabled"
      (keyup.enter)="applyDiscount()"
    />
    <button
      type="button"
      class="btn btn-primary"
      (click)="applyDiscount()"
      [disabled]="disabled"
    >
      <span translate>APPLY</span>
    </button>
  </div>
</div>
